import { render, staticRenderFns } from "./AbonnementsList.vue?vue&type=template&id=2f1aaa68&"
import script from "./AbonnementsList.vue?vue&type=script&lang=js&"
export * from "./AbonnementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports